import * as THREE from 'three';
import { roofAtlas, type RoofAtlas } from './roofImageryMath';

// Display modes replace mesh.material; the aerial loader must still find the
// solid roof texture when a site is opened directly in x-ray mode.
export const roofTextures = new WeakMap<THREE.Object3D, THREE.Texture>();
export const roofTextureAtlases = new WeakMap<THREE.Texture, RoofAtlas>();
export const roofTextureSources = new WeakMap<THREE.Texture, {coordinates: number[][]; maxTiles: number}>();

/** Keep one texture identity through material cloning and asynchronous tile loading. */
export function createRoofTexture(coordinates: number[][], maxTiles = 64): THREE.Texture | null {
  const atlas = roofAtlas(coordinates, maxTiles);
  if (!atlas) return null;
  // Procedural models are also built by Node catalogue scripts. The browser
  // supplies the canvas on mount, before requesting the aerial tiles.
  const texture = new THREE.Texture();
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 16;
  roofTextureAtlases.set(texture, atlas);
  roofTextureSources.set(texture, {coordinates, maxTiles});
  return texture;
}
